export default {
    "staging2.edubricz.net": "UA-207346724-1",
    "staging3.edubricz.net": "UA-207346724-2",
    "staging4.edubricz.net": "UA-207346724-3",
    "staging5.edubricz.net": "UA-207346724-4",
}